/**
 * Set up routing for all Answer views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import answer views
import CreateAnswer from './views/CreateAnswer.js.jsx';
import AnswerList from './views/AnswerList.js.jsx';
import SingleAnswer from './views/SingleAnswer.js.jsx';
import UpdateAnswer from './views/UpdateAnswer.js.jsx';

class AnswerRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/answers" component={AnswerList} />
        <YTRoute login={true} exact path="/answers/new" component={CreateAnswer} />
        <Route exact path="/answers/:answerId" component={SingleAnswer}/>
        <YTRoute login={true} exact path="/answers/:answerId/update" component={UpdateAnswer}/>
      </Switch>
    )
  }
}

export default AnswerRouter;



// WEBPACK FOOTER //
// modules/answer/AnswerRouter.js.jsx